export default __webpack_public_path__ + "static/media/Colour.48e41d9c.png";